import React, { memo } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from '../../src/i18n';
import SubTitle from '../SubTitle';
import { TP, LISTING_PAGE } from '../../constants/consts';
import { colors } from '../../constants/styleConstants';

const ResultTitle = styled.div`
  width: 100%;
  padding: 30px 30px 0;
  word-break: break-word;
  text-align: center;
`;

const useStyles = makeStyles(() => ({
  results: {
    padding: '8px 0',
  },
  resultsTitle: {
    color: colors.title,
    fontSize: '10px',
    textTransform: 'none',
    letterSpacing: 0,
  },
}));

const ListingPageResultsTitle = ({ message, options, numberResults, pageName }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const valuesToShow = Object.values(options)
    .reduce((values, value) => {
      const valueToShow = typeof value === 'string' ? value : get(value, 'label');
      if (valueToShow && valueToShow !== 'All') {
        return [...values, `"${valueToShow}"`];
      }
      return values;
    }, [])
    .join(', ');
  return (
    <>
      {valuesToShow.length > 0 && !pageName && (
        <ResultTitle>
          <SubTitle>{`${t(message)}: ${valuesToShow}`}</SubTitle>
        </ResultTitle>
      )}
      {valuesToShow.length > 0 && pageName === LISTING_PAGE && (
        <div className={classes.results}>
          <SubTitle className={classes.resultsTitle}>
            {`${t('operabase.general.m_SEARCHRESULTS')} (${numberResults}) for ${valuesToShow}`}
          </SubTitle>
        </div>
      )}
    </>
  );
};

ListingPageResultsTitle.propTypes = {
  // form values
  options: PropTypes.object,
  message: PropTypes.string,
  pageName: PropTypes.string,
  numberResults: PropTypes.number,
};

ListingPageResultsTitle.defaultProps = {
  options: {},
  message: `${TP}.FN_LISTINGS_SHOW_RESULTS`,
};

export default memo(ListingPageResultsTitle);
